<script>
export default {
    name: 'FooterComponent',
};
</script>

<template>
    <div class="container">
        <div class="footer-container">
            <div class="footer-left">
                <a class="title text-light footer-link" href="#head">My<span class="orange">VPN</span></a>
                <div class="footer-info">
                    <p class="info-item text-medium text-light">Компания: SOFTEKA - FZCO</p>
                    <p class="info-item text-medium text-light">Номер лицензии: 55022</p>
                    <p class="info-item text-medium text-light">Юридический адрес: IFZA Business Park, Building A1, Dubai Digital Park, Dubai Silicon Oasis, Dubai, United Arab Emirates</p>
                </div>
                <p class="copyright text-medium text-light">© 2025 MyVPN</p>
            </div>
            <div class="footer-center">
                <h3 class="footer-title text-medium text-light">Документы</h3>
                <ul class="footer-nav-list">
                    <li class="nav-item">
                        <router-link class="link" to="/privacy">Политика конфиденциальности</router-link>
                    </li>
                    <li class="nav-item">
                        <router-link class="link" to="/terms">Условия пользования</router-link>
                    </li>
                </ul>
            </div>
            <div class="footer-right">
                <h3 class="footer-title text-medium text-light">Способы оплаты</h3>
                <ul class="right-list">
                    <li class="right-item"><img src="../../assets/images/master.svg" alt="Mastercard"></li>
                    <li class="right-item"><img src="../../assets/images/visa.svg" alt="Visa"></li>
                    <li class="right-item"><img src="../../assets/images/peace.svg" alt="Mir"></li>
                </ul>
            </div>

            <div class="footer-min">
                <ul class="min-nav-list">
                    <li class="min-nav-item">
                        <router-link class="link" to="/privacy">Политика конфиденциальности</router-link>
                    </li>
                    <li class="min-nav-item">
                        <router-link class="link" to="/terms">Условия пользования</router-link>
                    </li>
                </ul>
                <ul class="min-top-list">
                    <li class="min-item"><img src="../../assets/images/master.svg" alt="Mastercard"></li>
                    <li class="min-item"><img src="../../assets/images/visa.svg" alt="Visa"></li>
                    <li class="min-item"><img src="../../assets/images/peace.svg" alt="Mir"></li>
                </ul>
                <ul class="min-bottom-list">
                    <li class="min-item"><a target="_blank" href="https://apps.apple.com/it/app/myvpn/id6479427630"><img
                                src="../../assets/images/apple.svg" alt="Apple"></a></li>
                    <li class="min-item"><a target="_blank"
                            href="https://play.google.com/store/apps/details?id=ai.myvpn.app"><img
                                src="../../assets/images/android.svg" alt="Google"></a></li>
                </ul>
            </div>
        </div>
    </div>
</template>

<style scoped>
.footer-info {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.info-item {
    margin: 0;
    line-height: 1.5;
}

.copyright {
    margin-top: 20px;
    margin-bottom: 0;
}

.footer-title {
    margin: 0 0 16px 0;
    font-weight: 600;
}

.footer-nav-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
    list-style: none;
    padding: 0;
    margin: 0;
}

.nav-item {
    margin: 0;
}

.nav-item > .link {
    color: var(--secondary-color);
    transition: all 0.3s ease;
    text-decoration: none;
}

.nav-item > .link:hover {
    color: var(--orange-color);
}

.footer-center {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}

.footer-right {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
}

.right-list {
    display: flex;
    gap: 12px;
    list-style: none;
    padding: 0;
    margin: 0;
}

.right-item {
    padding: 8px 12px;
    border-radius: 8px;
    background: rgba(254, 253, 248, 0.2);
    display: flex;
    align-items: center;
    justify-content: center;
}

.right-item img {
    display: block;
    height: auto;
}

.min-nav-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
    list-style: none;
    padding: 0;
    margin: 0 0 20px 0;
}

.min-nav-item {
    margin: 0;
}

.min-nav-item > .link {
    color: var(--secondary-color);
    transition: all 0.3s ease;
    text-decoration: none;
    font-size: 14px;
}

.min-nav-item > .link:hover {
    color: var(--orange-color);
}
</style>